import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import axios from "axios";
import { TokenResponse } from "../ConnectionInterface";

export const fetchRecordingDetailsAPI = async (
  deviceId: string,
): Promise<any[]> => { 
  try {
    let url = `${NGROK}/api/guacamole/get-history?computerId=${deviceId}`;
    const response = await apiClient<any[]>({  
      method: "GET",
      url
    });
    return response;
  } catch (error) {
    console.error("Error fetching audit logs:", error);
    return [];  
  }
};





export const getToken = async (
  email: string,
  computerId: string,
  userRole: string
): Promise<TokenResponse | undefined> => {
  try {
    const { data } = await axios.get<TokenResponse>(
      `${NGROK}/api/access/${userRole}/get-token`,
      {
        params: { email, computerId },
      }
    );
    return data; // returns { authToken }
  } catch (error) {
    console.error("getToken error:", error);
  }
};

export const saveToken = async (
  email: string,
  computerId: string,
  userRole: string
): Promise<TokenResponse | undefined> => {
  try {
    const { data } = await axios.post<TokenResponse>(
      `${NGROK}/api/access/${userRole}/save-token`,
      {
        email,
        computerId,
      }
    );
    return data; // returns { authToken }
  } catch (error) {
    console.error("saveToken error:", error);
  }
};
